import {
  Layout,
  Menu,
  Button,
  Row,
  Col,
  message,
  Drawer,
  Input,
  Select,
} from "antd";
import React, { useEffect, useState, useRef } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import styled from "styled-components";
import axios from "axios";
import ExampleFooter from "./ExampleFooter";
import { MenuOutlined, HomeOutlined } from "@ant-design/icons";
import { GlobalSearch } from "../GlobalSearch";
import { useWebsiteBasicInformation } from "../controller/WebsiteBasicInformationController";

const { Header, Footer, Content } = Layout;
const { Search } = Input;
const InputOutline = styled.div`
  .ant-input-status-error {
    border-top-style: hidden;
    border-right-style: hidden;
    border-left-style: hidden;
    border-bottom-style: groove;
    border-radius: 0px;
    background-color: #f5f5f5;
    border-width: 5px;
  }
`;
const NavBar = ({
  admin = false,
  menuData = [
    {
      label: "網站總覽",
      key: "/officialweb/admin",
    },
    {
      label: "網站設定",
      key: "/officialweb/admin/management",
    },
    {
      label: "選單管理",
      key: "/officialweb/admin/routeSetting",
    },
    {
      label: "文章管理",
      key: "/officialweb/admin/articlemanagement",
    },
    {
      label: "諮詢管理",
      key: "/officialweb/admin/appointment",
    },
    {
      label: "前台首頁",
      key: "/officialweb/frontend",
    },
  ],
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [back, setBack] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [content, setContent] = useState("");
  const [open_wyswyg, set_open_wyswyg] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [footerData, setFooterData] = useState([]);
  // const [permission, setPermission] = useState(false);
  const [selecte_keys, setSelectedKeys] = useState(window.location.pathname);
  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });
  const [footerLogo, setFooterLogo] = useState([]);
  const [headerLogo, setHeaderLogo] = useState([]);
  const [files, setFiles] = useState([]);

  const onSelect = (e) => {
    navigate(e.key);
    // document.title = titles[e.key]
    setSelectedKeys([e.key]);
    setCollapsed(false);
    // console.log(e.key)
  };

  useEffect(() => {
    // console.log(menuData)
    const debouncedHandleResize = function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    };
    window.addEventListener("resize", debouncedHandleResize);

    return (_) => {
      window.removeEventListener("resize", debouncedHandleResize);
    };
  }, []);

  const get_identity = () => {
    axios.get("/officialWeb/backend/permission").then((response) => {
      if (response.data.length !== 0) {
        setBack(true);
      }
    });
  };
  useEffect(() => {
    setSelectedKeys([window.location.pathname]);
    // document.title = titles[window.location.pathname]
    // get_identity();
    // visit_log()
    // if (window.location.pathname.split('/').length === 4) {
    //     let source = window.location.pathname.split('/')[2];
    //     if (source === 'ClassIntroduce') {
    //         document.title = '課程簡介';
    //     } else if (source === 'News') {
    //         document.title = '最新消息';
    //     } else if (source === 'ShareLearning') {
    //         document.title = '學習見證分享';
    //     } else {
    //         document.title = '上課花絮';
    //     }
    // }
  }, [window.location.pathname]);
  const handleUpdate = () => {
    var Today = new Date();
    let time = `${Today.getFullYear()}-${
      Today.getMonth() + 1
    }-${Today.getDate()}`;
    axios
      .patch(`/officialWeb/backend/blog/contact_us`, [
        {
          title: "聯繫我們",
          content: content,
          blog_type_id: 10,
          annoucement_time: time,
          blog_id: 116,
        },
      ])
      .then((response) => {
        if (response.data.status === "failure") {
          set_open_wyswyg(false);
          messageApi.open({
            type: "error",
            content: "修改失敗",
          });
        } else {
          set_open_wyswyg(false);
          messageApi.open({
            type: "success",
            content: "修改成功",
          });
        }
        // get_header();
        // set_open_wyswyg(false);
      });
  };
  const onSearch = () => {};
  const onFinish = ({ axiosMode, status, values }) => {
    if (status === "success") {
      if (axiosMode === "post") {
        message.success("送出成功");
        // actionRef.current.reloadAndRest();
      } else if (axiosMode === "patch") {
        message.success("修改成功");
        // actionRef.current.reloadAndRest();
      } else if (axiosMode === "delete") {
        message.success("刪除成功");
        // actionRef.current.reloadAndRest();
        // setSelectedRowKeys([])
        // setSelectedRowsInfo([])
      }
      // setModalLoading(false)
      // setModalOpen(false)
    } else if (status === "error") {
      if (axiosMode === "post") {
        message.error("新增失敗");
        // actionRef.current.reloadAndRest();
      } else if (axiosMode === "patch") {
        message.error("修改失敗");
        // actionRef.current.reloadAndRest();
      } else if (axiosMode === "delete") {
        message.error("刪除失敗");
        // actionRef.current.reloadAndRest();
      }
      // setModalLoading(false)
      // setModalOpen(false)
    }
  };
  const onBefore = ({ axiosMode, status, values }) => {
    // setModalLoading(true)
  };
  const {
    WebsiteBasicInformationData,
    getWebsiteBasicInformationData,
    patchWebsiteBasicInformationClickData,
    // postWebsiteBasicInformationData,
    // patchWebsiteBasicInformationData,
    // deleteAppointmentData,
  } = useWebsiteBasicInformation({
    onFinish,
    onBefore,
  });

  const get_picture = (file_id) => {
    let file = files.find((element) => element.file_id === file_id);
    let file_url = file?.file_url;
    return file_url;
  };
  const getAllpictures = (temp) => {
    temp.forEach((element) => {
      if (element?.file_id) {
        axios
          .get("/component/file", {
            responseType: "blob",
            params: {
              file_id: element?.file_id,
            },
          })
          .then((response) => {
            var blob_ = new Blob([response.data], {
              type: "image/jpg", // this is the only MIME for SVG
            });
            const dataurl = URL.createObjectURL(blob_);
            setFiles((pre) => {
              return [
                ...pre,
                {
                  file_id: element?.file_id,
                  file_url: dataurl,
                },
              ];
            });
          });
      }
    });
  };

  useEffect(() => {
    // console.log(footerData)
    if (footerData && footerData.length !== 0) {
      footerData?.classify_structure_type_data.forEach(
        (classify_structure_type_data) => {
          if (classify_structure_type_data.title === "Logo") {
            getAllpictures(
              classify_structure_type_data?.classify_structure_type_file_data ??
                []
            );
            classify_structure_type_data?.classify_structure_type_file_data.forEach(
              (file) => {
                setHeaderLogo(file);
              }
            );
          }
        }
      );
      // setFooterInformation(footerData?.classify_structure_type_data)
    }
  }, [footerData]);

  useEffect(() => {
    WebsiteBasicInformationData.forEach((item) => {
      setFooterData(item);
      patchWebsiteBasicInformationClickData([
        {
          information_id: item.information_id,
        },
      ]);
    });
  }, [WebsiteBasicInformationData]);

  useEffect(() => {
    getWebsiteBasicInformationData();
  }, []);

  return (
    <>
      {contextHolder}

      <Layout className="layout">
        <Header style={{ backgroundColor: "#ffffff" }}>
          {dimensions["width"] > 1102 ? (
            <>
              <Row align={"middle"} justify={"space-between"}>
                {headerLogo && headerLogo.length !== 0 ? (
                  <Col
                    className="example"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => navigate("/officialweb/frontend/")}
                  >
                    <img
                      width="auto"
                      height="64px"
                      src={get_picture(headerLogo.file_id)}
                    ></img>
                    {/* <img width="auto" height='64px' src='/cram_school/logo_EMI.png'></img> */}
                  </Col>
                ) : (
                  <Col
                    className="example"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => navigate("/officialweb/frontend/")}
                  >
                    <img
                      width="auto"
                      height="64px"
                      src="/cram_school/logo.png"
                    ></img>
                    {/* <img width="auto" height='64px' src='/cram_school/logo_EMI.png'></img> */}
                  </Col>
                )}
                <Col span={16}>
                  <Menu
                    // style={{ position: 'relative', display: 'flex', justifyContent: 'center' }}
                    theme="light"
                    mode="horizontal"
                    defaultSelectedKeys={["/officialweb/frontend/"]}
                    selectedKeys={selecte_keys}
                    onSelect={onSelect}
                    right
                    items={menuData}
                  />
                </Col>
                {admin && (
                  <>
                    <Col>
                      <Row align={"bottom"}>
                        <Col>{/* <GlobalSearch /> */}</Col>
                      </Row>
                    </Col>
                    {/* <Col >
                                    <Row
                                        align={"middle"}

                                    >
                                        <Col>
                                            <Button style={{ backgroundColor: '#1F9798' }} type="primary">免費預約諮詢</Button>
                                        </Col>
                                    </Row>
                                </Col> */}
                  </>
                )}
              </Row>
            </>
          ) : (
            <>
              <Row justify={"space-between"}>
                {headerLogo && headerLogo.length !== 0 ? (
                  <Col
                    className="example"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => navigate("/officialweb/frontend/")}
                  >
                    <img
                      width="auto"
                      height="64px"
                      src={get_picture(headerLogo.file_id)}
                    ></img>
                  </Col>
                ) : (
                  <Col
                    className="example"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => navigate("/officialweb/frontend/")}
                  >
                    <img
                      width="auto"
                      height="64px"
                      src="/cram_school/logo.png"
                    ></img>
                  </Col>
                )}

                <Col>
                  <MenuOutlined
                    onClick={(e) => {
                      setCollapsed(!collapsed);
                    }}
                    style={{
                      marginBottom: 16,
                      cursor: "pointer",
                    }}
                  />
                </Col>
              </Row>
            </>
          )}
        </Header>
        <Content
          style={{
            // padding: '30px 50px',
            fontSize: "18px",
            // background: '#f5f5f5'
            background: "#FFFFFF",
          }}
        >
          {dimensions["width"] <= 1102 ? (
            <>
              <Drawer
                placement="right"
                open={collapsed}
                onClose={() => setCollapsed(false)}
              >
                <Row>
                  <Col span={24}>{/* <GlobalSearch width={'100%'} /> */}</Col>
                </Row>
                <Menu
                  mode="inline"
                  defaultSelectedKeys={["/"]}
                  selectedKeys={selecte_keys}
                  onClick={onSelect}
                  items={menuData}

                  // style={{
                  //     whiteSpace: 'nowrap',
                  // width: '100%',
                  //     textAlign: 'center',
                  //     position: 'relative',
                  //     display: 'flex',
                  //     justifyContent: 'center'
                  // }}
                />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    margin: "18px 0px",
                  }}
                >
                  <Button style={{ backgroundColor: "#1F9798" }} type="primary">
                    免費預約諮詢
                  </Button>
                </div>
              </Drawer>
            </>
          ) : null}
          <Row gutter={[0, 8]}>
            {admin ? (
              <>
                <Col span={24}>
                  <Row justify={"end"}>
                    <Col>
                      <Button
                        type="primary"
                        className="example"
                        onClick={(e) => navigate("/officialWeb/admin")}
                      >
                        回到後台
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </>
            ) : null}
            <Col span={24}>
              <Outlet />
            </Col>
          </Row>
        </Content>
        <ExampleFooter footerData={footerData} />
      </Layout>
    </>
  );
};
export default NavBar;
